// extracted by mini-css-extract-plugin
export var spinner = "loading-spinner-module--spinner--25dc5";